import { GestureIcon } from './GestureIcon';

/**
 * author: Google
 * id FFC2833D-65AB-47BB-AC7C-8CFA41DF9250
 * name gesture
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gesture.svg
 * tags
 * - Drawing / Art 
 */
export const FreehandLineIcon = GestureIcon;
export default FreehandLineIcon